export default "__VITE_ASSET__DyAZyJFH__"